import React from "react";
import { Offcanvas, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import { clearCart, selectCartItems, selectCartTotal } from "../../../store/cartSlice";
import {
  selectCartItems,
  selectCartTotal,
  increaseQty,
  decreaseQty,
  removeItem,
  clearCart,
} from "../../../store/cartSlice";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth-pages/AuthContext";
import CheckoutButton from "./CheckoutButton";

const format = (v) => (Number(v) || 0).toLocaleString();

const CartDrawer = ({ show, onHide }) => {
  const items = useSelector(selectCartItems);
  const total = useSelector(selectCartTotal);
  const dispatch = useDispatch();
  const pathUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  //   const isLoggedIn = useSelector((state) => state.auth.isLoggedIn); // check login state

  const customer = JSON.parse(localStorage.getItem("customer"));
  const { auth } = useAuth();

  const handleCheckout = () => {
    if (auth.isLoggedIn) {
      navigate("/checkout");
    } else {
      navigate("/login"); // go to login page
    }
  };

  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>My Cart</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {items.length === 0 ? (
          <>
            {!customer ? (
              <>
                <p className="text-muted">Your cart is empty.</p>
                <div className="text-center mx-2">
                  <button
                    className="btn btn-sm mt-5"
                    style={{ backgroundColor: "#4c934c", color: "white" }}
                    onClick={() => navigate("/page/categories")}
                  >
                    Add Item
                  </button>
                </div>{" "}
              </>
            ) : (
              <>
                <div className="mt-2 text-center">
                  <CheckoutButton />
                </div>
              </>
            )}
          </>
        ) : (
          <>
            {items.map((item) => (
              <div key={item.id} className="d-flex align-items-center mb-3">
                <img
                  src={pathUrl + item.image || "/assets/img/no-image.jpg"}
                  alt={"img"}
                  width={64}
                  height={64}
                  className="rounded me-2"
                  style={{ objectFit: "cover" }}
                />
                <div className="flex-grow-1">
                  <div className="fw-semibold">{item.name}</div>
                  <div className="text-muted">₹ {format(item.price)}</div>
                  <div className="d-flex align-items-center mt-1">
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={() => dispatch(decreaseQty(item.id))}
                    >
                      –
                    </button>
                    <span>{item.qty}</span>
                    <button
                      className="btn btn-sm btn-outline-secondary ms-2"
                      onClick={() => dispatch(increaseQty(item.id))}
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="text-end">
                  <div>₹ {format(item.qty * item.price)}</div>
                  <button
                    className="btn btn-sm btn-link text-danger"
                    onClick={() => dispatch(removeItem(item.id))}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <strong>Total</strong>
              <strong>₹ {format(total)}</strong>
            </div>
            <div className="d-flex gap-2 mt-3">
              <Button
                variant="outline-danger"
                onClick={() => dispatch(clearCart())}
              >
                Clear
              </Button>
              <CheckoutButton />
              {/* <Button
                variant="danger"
                style={{ backgroundColor: "#4c934c", color: "white" }}
                // onClick={() => alert("Proceed to checkout (frontend only)")}
                onClick={handleCheckout}
                security="public"
                access="public"
                size="md"
              >
                Checkout
              </Button> */}
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
    // <></>
  );
};

export default CartDrawer;
